import noUiSlider from 'nouislider';

class Slider {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-slider="scope"]',
			min: '[data-slider="min"]',
			max: '[data-slider="max"]',
			slider: '[data-slider="slider"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, element) => {
			let $scope = $(element);
			let $slider = $scope.find(this.config.slider);

			let min = parseFloat($scope.data('min'));
			let max = parseFloat($scope.data('max'));

			let settings = Object.assign({
				start: [parseFloat($scope.find(this.config.min).val()), parseFloat($scope.find(this.config.max).val())],
				connect: true,
				step: 1,
				range: {
					min: min,
					max: max
				},
			}, $slider.data())

			let plugin = noUiSlider.create($slider[0], settings);
			$slider.data('plugin', plugin);
			plugin.on('update', this.onUpdate.bind(this, $scope));
			plugin.on('end', this.onEnd.bind(this, $scope));
		})
	}

	onUpdate($scope, values, handle, unencoded, tap, positions, noUiSlider) {
		let $min = $scope.find('[data-scope="min"]');
		let $max = $scope.find('[data-scope="max"]');
		$min.html(values[0].replace(".00", ""));
		$max.html(values[1].replace(".00", ""));
	}

	onEnd($scope, values, handle, unencoded, tap, positions, noUiSlider) {
		let $min = $scope.find(this.config.min);
		let $max = $scope.find(this.config.max);
		$min.val(values[0]);
		$max.val(values[1]);
		$min.trigger('change');
		$max.trigger('change');
	}

	formatNumber(value) {
		return value.toFixed(0);
	}
}

export default Slider;
